﻿import Site from '../../es6/helpers/Site';

const documentLang = $('html')[0].lang;
const dataTableLangLocationUrl =
  '//' +
  window.location.hostname +
  '/Static/dist/scripts/jquery/vendor/language/dataTable_lang_' +
  documentLang +
  '.json';

$(function () {
  // The script will not run if the site url is not valid for:
  // .fi site and agrodesk, viljakauppa.
  if (!Site.isValidSite('.se', 'agrodesk') && !Site.isValidSite('.com', 'agrodesk') && !Site.isValidSite('.fi', 'agrodesk') && !Site.isValidSite('.fi', 'viljakauppa')) {
    return;
  }

  var oldGrainJson = prepareGrainDataJson();
  $('.lm__logo-item').parent().addClass('agrodesk');

  $('.datepicker-agrodesk').datetimepicker({
    controlType: 'select',
    oneLine: true,
    timeFormat: 'HH:mm',
    dateFormat: 'yy-mm-dd',
    minDate: new Date(),
  });

  $('.datepicker-agrodesk-finnish-format').datetimepicker({
    controlType: 'select',
    oneLine: true,
    timeFormat: 'HH:mm',
    dateFormat: 'dd/mm/yy',
    timeText: 'Aika',
    hourText: 'Tunti',
    minuteText: 'Minuutti',
    currentText: 'Nyt',
    closeText: 'Hyväksy',
    firstDay: 1,
    monthNames: [
      'Tammikuu',
      'Helmikuu',
      'Maaliskuu',
      'Huhtikuu',
      'Toukokuu',
      'Kesäkuu',
      'Heinäkuu',
      'Elokuu',
      'Syyskuu',
      'Lokakuu',
      'Marraskuu',
      'Joulukuu',
    ],
    dayNames: [
      'Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko',
      'Torstai', 'Perjantai', 'Lauantai'
    ],
    dayNamesMin: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
  });


  // UPLOAD FILE BLOCK
  $('.upload-files__file').change(function () {
    var names = [];
    for (var i = 0; i < $(this).get(0).files.length; ++i) {
      names.push($(this).get(0).files[i].name);
    }

    var tempid = $(this).attr('id').split('_')[1];
    $(this).next('#upload-file__placeholder').val(names.join(', '));

    if ($(this).val()) {
      $('#btn_' + tempid).attr('disabled', false);
    } else {
      $('#btn_' + tempid).attr('disabled', true);
    }
  });

  // NEWS PAGES, LIST and BLOCK
  if (document.getElementsByClassName('block__category-filter__update').length > 0) {
    $('article.lm__news-item.block__newslist__filtered').remove();
    LoadNewsList(CheckedCategoryNumbers(), NewsPagination());
  }

  function NewsPagination() {
    var newsPagination = 1;
    if ($('#newsPagination').val() !== null) {
      newsPagination = $('#newsPagination').val();
    }
    return newsPagination;
  }

  function CheckedCategoryNumbers() {
    var categoryNumbers = [];
    $('.selected_category:checkbox:checked').each(function (i) {
      categoryNumbers.push($(this).val());
    });
    return categoryNumbers;
  }

  function NewsList(data) {
    $.each(data.News, function (key, page) {
      $('section.lm__news.news-list').append(
        $(
          '<article class="lm__news-item block__newslist__filtered ' +
          (page.IsViewed ? 'viewed' : '') +
          ' ">'
        ).append(
          $('<a href="' + page.RelativeUrl + '">')
            .append($('<h4 class="article-title">').text(page.Heading))
            .append(
              $('<p class="article-datetime">')
                .text(page.Date)
                .append('<br /><i>' + page.Categories + '</i>')
            )
        )
      );
    });
  }

  function LoadNewsList(categoryNumbers, newsPagination) {
    var currentContentReference = $('#currentContentReference').val();
    var numberOfItems = $('#numberOfItems').val();
    var loadMoreNews = $('#loadMoreNews').val();
    var culture = $('#currentCulture').val();

    const jsonData = JSON.stringify({
      categoryNumbers: categoryNumbers,
      currentContentReference: parseInt(currentContentReference),
      numberOfItems: parseInt(numberOfItems),
      loadMoreNews: loadMoreNews === 'true',
      culture: culture,
      pagination: newsPagination,
    });

    $.ajax({
      method: 'POST',
      url: '/api/news/update-newslist',
      data: jsonData,
      dataType: 'json',
      contentType: 'application/json',
      success: function (data) {
        NewsList(data);
        let pagination = parseInt(newsPagination) + 1;
        $('#newsPagination').val(pagination);
        if (data.News.length < $('#numberOfItems').val()) {
          $('#btn__category-filter__update__load_more').attr('disabled', true);
        } else {
          $('#btn__category-filter__update__load_more').attr('disabled', false);
        }
      },
      error: function (data) {
        console.log(data.responseText);
      },
    });
  }

  $('#btn__category-filter__update__load_more').click(function () {
    LoadNewsList(CheckedCategoryNumbers(), NewsPagination());
  });

  $('#block__category-filter__update').click(function () {
    $('article.lm__news-item.block__newslist__filtered').remove();
    $('#newsPagination').val(1);
    LoadNewsList(CheckedCategoryNumbers(), NewsPagination());
  });

  function prepareGrainDataJson() {
    var grainPricesJson = [];
    $('#tblGrainPrices >tbody >tr').each(function () {
      var grainItem = {};
      var grainName = $('.spGrainName', this).text();
      var grainType = $('.hdnGrainType', this).val();
      var deliveryLocation = $('.deliveryLocation', this).html();
      grainItem['GrainName'] = grainName;
      grainItem['DeliveryLocation'] = deliveryLocation;
      grainItem['GrainType'] = grainType;
      var grainPrices = [];
      $('td', this).each(function () {
        var priceItem = {};
        if ($(this).index() > 1) {
          var grainPrice = $('.grainPrice', this).val();
          var monthId = $('.hdnMonthId', this).val();
          var priceMonth = $(
            '#tblGrainPrices >thead >tr > th:eq(' + $(this).index() + ')'
          )
            .find('.priceMonth')
            .val();
          priceItem['Month'] = priceMonth;
          priceItem['Price'] = grainPrice;
          priceItem['Id'] = monthId;
          grainPrices.push(priceItem);
        }
        grainItem['MonthPriceList'] = grainPrices;
      });
      grainPricesJson.push(grainItem);
    });
    return grainPricesJson;
  }

  $('#frmWarrantyform').validate({
    errorElement: 'span',
  });

  $('#btnUpdatePrices').click(function () {
    $('#spInstructions').hide();
    var newJson = prepareGrainDataJson();
    if (JSON.stringify(newJson) === JSON.stringify(oldGrainJson)) {
      $('#spInstructions').show();
      $('#spsuccess').hide();
      $('#spfailure').hide();
    } else {
      $.ajax({
        url: '/api/graintrade/updatemortgagegrainprices',
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(newJson),
        success: function (data) {
          if (window.location.href.indexOf('?') == -1) {
            window.location.href = window.location.href + '?success=true';
          } else {
            window.location.href = window.location.href.split('?')[0] + '?success=true';
          }
        },
        error: function (ex) {
          if (window.location.href.indexOf('?') == -1) {
            window.location.href = window.location.href + '?failed=true';
          } else {
            window.location.href = window.location.href.split('?')[0] + '?failed=true';
          }
        },
      });
    }
  });

  $('.mortageType input[type=radio]').change(function () {
    if ($(this).val() == 'Heti-Termiini') {
      $('.row-Sopimusnumero').css('display', 'none');
      $('#SopimusNumero').val('TE-');
    } else {
      $('.row-Sopimusnumero').css('display', 'inline-block');
      $('#SopimusNumero').val('');
    }
  });

  $('.mortgage-item-price').click(function () {
    var url = $(this).find('.hdnlink').val();
    var isMortgageAllowed = $(this).find('.hdnmortgageallowed').val();
    var price = $(this).find('.hdprice').val();
    if (isMortgageAllowed === 'True' && price !== '') window.location = url;
  });

  function checkIfGrainHasPrices(grains, grainType) {
    var lst = $.grep(grains, function (g) {
      g.GrainType = grainType && hasPrices(g.MonthPriceList);
    });

    lst.length > 0;
  }
  function hasPrices(grains) {
    var lst = $.grep(grains, function (g) {
      g.Price != null && x.Price != '';
    });
    return lst.length > 0;
  }
  MakeGrainPricesCollapsible();
  BindContracts();
  function MakeGrainPricesCollapsible() {
    $('.grain-block-item').each(function () {
      $('.grain-block').each(function () {
        var itemindex = $(this)
          .attr('id')
          .substring($(this).attr('id').lastIndexOf('_') + 1);
        if (itemindex != 0) {
          var itemName = $(this)
            .attr('id')
            .substring(0, $(this).attr('id').lastIndexOf('_'));

          if ($('#' + itemName + '_' + (itemindex - 1)).length > 0) {
            $(this).addClass('invisible');
            $(this).find('.mortgage-locations').addClass('invisible');
          } else if ($('#' + itemName + '_' + (itemindex * 1 + 1)).length == 0) {
            $(this).find('.mortgage-locations').addClass('invisible');
          }
        }
      });
    });
  }
  $('.mortgage-locations').click(function () {
    var grainName = $(this).attr('id').substring(0, $(this).attr('id').lastIndexOf('_A'));
    $('.' + grainName).removeClass('invisible');
    $(this).hide();
  });
  $('#btnSearchContractsData').click(function () {
    BindContracts();
  });
  function BindContracts() {
    if ($('#MortgageContractsList').length) {
      var table = $('#MortgageContractsList').dataTable();
      if (table != null) {
        table.fnDestroy();
      }
      var url = '/api/graintrade/contracts?';
      var params = '';
      if ($('#txtSearchInput').val() != '') {
        params = 'query=' + $('#txtSearchInput').val();
      }
      if ($('#txtFromDate').val() != '') {
        params =
          params == ''
            ? 'fromDate=' + $('#txtFromDate').val()
            : params + '&fromDate=' + $('#txtFromDate').val();
      }
      if ($('#txtToDate').val() != '') {
        params =
          params == ''
            ? 'toDate=' + $('#txtToDate').val()
            : params + '&toDate=' + $('#txtToDate').val();
      }
      url = url + params;
      table = $('#MortgageContractsList').dataTable({
        bServerSide: true, // for show progress bar
        bProcessing: true, // for process server side
        bFilter: false, // this is for disable filter (search box)
        bPaginate: true,
        orderMulti: false, // for disable multiple column at once
        bLengthChange: false,
        sAjaxSource: url,
        aoColumns: [
          {
            data: 'CreatedOn',
            mRender: function (data) {
              return (
                data.split('$')[0] +
                '<label class="submissionId" style="display:None" >' +
                data.split('$')[1] +
                '</label> '
              );
            },
          },
          { data: 'MortgageType' },
          { data: 'Firstname' },
          { data: 'LastName' },
          { data: 'Address' },
          { data: 'PostalCode' },
          { data: 'PostOffice' },
          { data: 'PhoneNumber' },
          { data: 'Email' },
          { data: 'Company' },
          { data: 'VATCode' },
          { data: 'LoadingBridge' },
          { data: 'LoadingHigh' },
          { data: 'Store' },
          {
            data: 'Grainname',
          },
          { data: 'GrainPrice' },
          { data: 'GrainInput' },
          { data: 'GrainWeight' },
          { data: 'SopimusNumero' },
          { data: 'DeliveryLocation' },
          { data: 'DeliveryPeriod' },
          { data: 'AdditionalInformaton' },
        ],
        oLanguage: {
          sUrl: dataTableLangLocationUrl,
        },
      });
    }
  }
  (function () {
    const container = document.querySelector('.warranty_form_Container');
    if (!container) return;

    const isSwedishForm = container.dataset.isSwedish.toLowerCase() === 'true';

    const validationMessage = isSwedishForm
      ? 'Detta fält är obligatoriskt.'
      : 'Tämä kenttä on pakollinen.';

    const observer = new MutationObserver(() => {
      container
        .querySelectorAll('.Form__Element__ValidationError')
        .forEach(el => {

          // DO NOT override custom cross-field errors
          if (el.getAttribute('data-custom-email-error') === 'true') {
            return;
          }

          if (el.textContent.trim() !== validationMessage) {
            el.textContent = validationMessage;
          }
        });
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });
  })();
  $(document).on('click', '.deleteSparePart', ({ target }) => {
    const { index } = target.dataset;
    const json = JSON.stringify({ index: parseInt(index) });
    $.ajax({
      url: window.location.href + '/DeleteSparePart',
      method: 'POST',
      data: json,
      contentType: 'application/json',
      async: false,
      success: function (data) {
        BindSparePartstable(data);
      },
    });

    return false;
  });
  $(document).on('click', '.deleteServiceHour', ({ target }) => {
    const { index } = target.dataset;
    const json = JSON.stringify({ index: parseInt(index) });
    $.ajax({
      url: window.location.href + '/DeleteServiceHour',
      method: 'POST',
      data: json,
      contentType: 'application/json',
      async: false,
      success: function (data) {
        BindServiceHourstable(data);
      },
    });

    return false;
  });

  function BindSparePartstable(data) {
    $('#tblSpareParts tbody').html('');
    var sparePartTotal = 0;
    for (var i = 0; i < data.length; i++) {
      var row = '<tr>';
      row += '<td>' + data[i].Maara + '</td>';
      row += '<td>' + data[i].LMVaraosanumero + '</td>';
      row += '<td>' + data[i].VaraosanNimi + '</td>';
      row += '<td>' + data[i].AHinta + '</td>';
      row += '<td>' + data[i].RivinHinta + '</td>';
      row +=
        "<td><a href='#' class='deleteSparePart' data-index='" + i + "'>poista</a> </td>";
      row += '</tr>';
      $('#tblSpareParts tbody').append(row);
      sparePartTotal += data[i].RivinHinta * 1;
    }
    $('#Warrantydata_VaraosatYhteensa').val(sparePartTotal);
    $('#Warrantydata_Yhteensa').val(
      sparePartTotal * 1 + $('#Warrantydata_TyotYhteensa').val() * 1
    );
  }
  function BindServiceHourstable(data) {
    $('#tblServiceHours tbody').html('');
    var serviceHourTotal = 0;
    for (var i = 0; i < data.length; i++) {
      var row = '<tr>';
      row += '<td>' + data[i].TakuutyonHintaPerTunt + '</td>';
      row += '<td>' + data[i].Maara + '</td>';
      row += '<td>' + data[i].Tyoseloste + '</td>';
      row += '<td>' + data[i].Hinta + '</td>';
      row +=
        "<td><a href='#' class='deleteServiceHour' data-index='" + i + "'>poista</a> </td>";
      row += '</tr>';
      $('#tblServiceHours tbody').append(row);
      serviceHourTotal += data[i].Hinta * 1;
    }
    $('#Warrantydata_TyotYhteensa').val(serviceHourTotal);
    $('#Warrantydata_Yhteensa').val(
      serviceHourTotal * 1 + $('#Warrantydata_VaraosatYhteensa').val() * 1
    );
  }
  $('#AddSparePart').click(function () {
    var amount = $('#txtAmount').val();
    var partNumber = $('#txtSparepartNumber').val();
    var partName = $('#txtSparepartName').val();
    var unitPrice = $('#txtPrice').val();
    var totalPrice = $('#txtItemTotal').val();
    if (
      amount == '' ||
      partNumber == '' ||
      partName == '' ||
      unitPrice == '' ||
      totalPrice == ''
    ) {
      return false;
    }
    var json = JSON.stringify({
      Maara: amount,
      LMVaraosanumero: partNumber,
      VaraosanNimi: partName,
      AHinta: unitPrice,
      RivinHinta: totalPrice,
    });

    $.ajax({
      url: window.location.href + '/addsparepart',
      method: 'POST',
      data: json,
      contentType: 'application/json',
      async: false,
      success: function (data) {
        BindSparePartstable(data);
        $('#txtAmount').val('');
        $('#txtSparepartNumber').val('');
        $('#txtSparepartName').val('');
        $('#txtPrice').val('');
        $('#txtItemTotal').val('');
      },
    });

    return false;
  });

  $('#AddServiceHours').click(function () {
    var pricePerHour = $('#txtPricePerHour').val();
    var hours = $('#txtHours').val();
    var explaination = $('#txtExplaination').val();
    var rowPrice = $('#txtRowPrice').val();

    if (pricePerHour == '' || hours == '' || explaination == '' || rowPrice == '') {
      return false;
    }
    var json = JSON.stringify({
      TakuutyonHintaPerTunt: pricePerHour,
      Maara: hours,
      Tyoseloste: explaination,
      Hinta: rowPrice,
    });

    $.ajax({
      url: window.location.href + '/AddServiceHours',
      method: 'POST',
      data: json,
      contentType: 'application/json',
      async: false,
      success: function (data) {
        BindServiceHourstable(data);
        $('#txtHours').val('');
        $('#txtExplaination').val('');
        $('#txtPrice').val('');
        $('#txtRowPrice').val('');
      },
    });

    return false;
  });

  $('.updateSparePartPrice').change(function () {
    var amount = $('#txtAmount').val();
    var unitPrice = $('#txtPrice').val();
    if (!isNaN(amount) && !isNaN(unitPrice)) {
      $('#txtItemTotal').val(amount * unitPrice);
    } else {
      $('#txtItemTotal').val('');
    }
  });
  $('.updateServicehourPrice').change(function () {
    var pricePerHour = $('#txtPricePerHour').val();
    var hours = $('#txtHours').val();
    if (!isNaN(pricePerHour) && !isNaN(hours)) {
      $('#txtRowPrice').val(pricePerHour * hours);
    } else {
      $('#txtRowPrice').val('');
    }
  });
  $('#frmWarrantyform').submit(function (event) {
    if ($(this).valid()) {
      var sparepartCount = $('#tblSpareParts td').length;
      var servicehourCount = $('#tblServiceHours td').length;
      if (sparepartCount == 0 && servicehourCount == 0) {
        alert('Syötä varaosa tai työtunnit!');
        return false;
      }
    } else {
      return false;
    }

    var values = $('#Warrantydata_TakuunAlkamispaivamaara').val().split('/');
    var newValues = values[1] + '/' + values[0] + '/' + values[2];
    var releaseDate = new Date(newValues);
    var currentDate = new Date();
    var days = (currentDate - releaseDate) / (60 * 60 * 24 * 1000);

    if (days >= 366) {
      if (
        confirm(
          'Huomioi takuun voimassaolo. Ota tarvittaessa yhteys huoltoinsinööreihin: takuut.agro@lantmannenagro.fi'
        )
      ) {
        return true;
      }
      return false;
    }
    return true;
  });

  $('#Warrantydata_KoneenSarjanumero').change(function () {
    if ($(this).val() != '') {
      $.ajax({
        url:
          '/api/epiformsdata/warrantyformbyserialnumber?serialnumber=' +
          $('#Warrantydata_KoneenSarjanumero').val(),
        method: 'GET',
        contentType: 'application/json',
        async: false,
        success: function (data) {
          $('#Warrantydata_AsiakasEtunimi').val(data.CustomerFirstName);
          $('#Warrantydata_AsiakasSukunimi').val(data.CustomerLastName);
          $('#Warrantydata_AsiakasOsoite').val(data.CustomerAddress);
          $('#Warrantydata_AsiakasPostinumero').val(data.CustomerPostalCode);
          $('#Warrantydata_AsiakasPostitoimipaikka').val(data.CustomerPostalCity);
          $('#Warrantydata_AsiakasPuhelinNumero').val(data.CustomerPhoneNumber);
          $('#Warrantydata_AsiakasSahkoposti').val(data.CustomerEmail);
          $('#Warrantydata_KoneenMerkkiJaMalli').val(data.MaachineMakeAndModel);
          $('#Warrantydata_TakuunAlkamispaivamaara').val(data.ReleaseDate);
        },
      });
    }
  });

  BindReleaseAndWarrantyFormData();
  BindOldXFormData();
  BindWarrantyFormData();
  prefillSellerInfo();

  if ($('.warranty_form_Container').length > 0) {
    var container = $('.warranty_form_Container');
    var isSwedishForm = container.data('is-swedish').toLowerCase();
    var pageId = container.data('page-id');
    // Fetch labels only if it's a Swedish form
    if (isSwedishForm === "true") {
      $.ajax({
        type: 'GET',
        url: '/api/epiformsdata/getreleaseformlabels?pageId=' + pageId,
        dataType: 'json',
        success: function (response) {
          if (!response.labels || Object.keys(response.labels).length === 0) return;

          const labels = response.labels;
          for (const fieldIdKey in labels) {
            const fieldId = fieldIdKey;
            const translatedLabel = labels[fieldId];
            const $fieldContainer = $(`[data-f-element-name="${fieldId}"]`);
            if ($fieldContainer.data('f-type') === 'choice') {
              $fieldContainer.find('legend.Form__Element__Caption').text(translatedLabel);
            }
            else {
              const $labelElement = $fieldContainer.find('label');

              if ($labelElement.length && translatedLabel) {
                $labelElement.text(translatedLabel);
              }
            }
          }
        }
      });
    }
    $('.warranty_form_Container .ddlManufacturer').parent().css('float', 'left');

    var isCurrentFormSwedish = (container.data('is-swedish') || '').toString().toLowerCase() === 'true';
    var sellerSignatureText = isCurrentFormSwedish
      ? 'Försäljarens underskrift'
      : 'Myyjan allekirjoitus';

    var buyerSignatureText = isCurrentFormSwedish
      ? 'Köparens underskrift'
      : 'Ostajan allekirjoitus';
    var warrantyFooterText = isCurrentFormSwedish
      ? 'Garantin gäller endast om detta intyg är fullständigt ifyllt och undertecknat.'
      : 'Takuu on voimassa vain mikäli tämä todistus on kokonaan täytetty ja allekirjoitettu.';

    $(
      '<div class="visible-print">' +
      '<div class="Form__Element FormTextbox" style="float:left;" data-f-type="textbox">' +
      '<label class="Form__Element__Caption">' + sellerSignatureText + '</label>' +
      '<input type="text" class="FormTextbox__Input">' +
      '</div>' +
      '<div class="Form__Element FormTextbox" data-f-type="textbox">' +
      '<label class="Form__Element__Caption">' + buyerSignatureText + '</label>' +
      '<input type="text" class="FormTextbox__Input">' +
      '</div>' +
      '</div>' +
      '<small class="visible-print">' +
      warrantyFooterText +
      '</small>'
    ).insertBefore('.warranty_form_Container .FormSubmitButton');
    $('.warranty_form_Container hr:last').remove();

    if (isSwedishForm === "true") {
      $('.warranty_form_Container button[type="submit"]').text('Skriva ut och skicka');

      $('.warranty_form_Container .printInstructions')
        .text('När du har klickat på Skriv ut och skicka, öppnas ett bekräftelsefönster för formulärets skickande. Om du bekräftar att formuläret ska skickas, kan du efter bekräftelsen skriva ut formuläret.');
      TranslateAllRadioListTextsToSwedish();
      TranslateAllSeparatorTextsToSwedish();
      TranslateAllValidationErrorsToSwedish();
    }
  }

  validateCustomerAndSellersEmailDuplication();
  function TranslateAllRadioListTextsToSwedish() {
    $('.warranty_form_Container .FormChoice__Label').each(function () {
      const text = $(this).text().trim();

      if (text === 'Kyllä') {
        $(this).text('Ja');
      } else if (text === 'Ei') {
        $(this).text('Nej');
      }
      else if (text === 'Tilaan sähköpostiin uutiskirjeen') {
        $(this).text('Jag vill prenumerera på nyhetsbrevet via e-post.');
      }
    });
  }

  function TranslateAllSeparatorTextsToSwedish() {

    const h3TextMap = {
      "Asiakas": "Kund",
      "Myyjä": "Försäljäre",
      "Kone": "Maskin",
      "Moottori": "Motor",
      "Traktori": "Traktor",
      "Huolto-ja-varaosat": "Underhåll och reservdelar",
      "Luovutus": "Överföring",
      'Luovutuksen-yhteydessä-ostajalle-selvitettiin': 'Vid överlåtelsen informerades köparen om att',
      'Olen-vastaanottanut-seuraavat-asiakirjat': 'Jag har mottagit följande dokument',
      'Allekirjoitukset': 'Signaturer',
    };

    const h4TExtMap = {
      "Tätä-takuu-ja-luovutustodistusta-säilytettävä-10-vuotta": "Detta garanti- och överlåtelseintyg ska förvaras i 10 år."
    }

    $('.warranty_form_Container h3').each(function () {
      const $h3 = $(this);

      $.each(h3TextMap, function (cssClass, newText) {
        if ($h3.hasClass(cssClass)) {
          $h3.text(newText);
        }
      });
    });

    $('.warranty_form_Container h4').each(function () {
      const $h4 = $(this);

      $.each(h4TExtMap, function (cssClass, newText) {
        if ($h4.hasClass(cssClass)) {
          $h4.text(newText);
        }
      });
    });
  }

  function TranslateAllValidationErrorsToSwedish() {
    $('.warranty_form_Container .Form__Element__ValidationError')
      .text('Detta fält är obligatoriskt.');
  }
  function PrepareUrl(formtype) {
    var url = '/api/epiformsdata/releaseandwarrantyform?';
    if (formtype == 'warrantyform') {
      url = '/api/epiformsdata/warrantyform?';
    } else if (formtype == 'oldxformdata') {
      url = '/api/epiformsdata/oldxformdata?';
    }
    var params = '';
    if ($('#txtSearchInput').val() != '') {
      params = 'query=' + $('#txtSearchInput').val();
    }
    if ($('#ddlStores').val() != undefined && $('#ddlStores').val() != '') {
      params =
        params == ''
          ? 'store=' + $('#ddlStores').val()
          : params + '&store=' + $('#ddlStores').val();
    }
    if ($('#ddlManufacturer').val() != '') {
      params =
        params == ''
          ? 'manufacturer=' + $('#ddlManufacturer').val()
          : params + '&manufacturer=' + $('#ddlManufacturer').val();
    }
    if ($('#txtFromDate').val() != '') {
      params =
        params == ''
          ? 'fromDate=' + $('#txtFromDate').val()
          : params + '&fromDate=' + $('#txtFromDate').val();
    }
    if ($('#txtToDate').val() != '') {
      params =
        params == ''
          ? 'toDate=' + $('#txtToDate').val()
          : params + '&toDate=' + $('#txtToDate').val();
    }
    if ($('#chkSelf').is(':checked')) {
      params = params == '' ? 'submittedByMe=true' : params + '&submittedByMe=true';
    }
    if (formtype == 'warrantyform') {
      var checkedStatuses = '';
      if ($('#chkVastaanotettu').is(':checked')) {
        checkedStatuses = 'Vastaanotettu';
      }
      if ($('#chkKasittelyssa').is(':checked')) {
        checkedStatuses += checkedStatuses == '' ? 'Käsittelyssä' : ',Käsittelyssä';
      }
      if ($('#chkHyväksytty').is(':checked')) {
        checkedStatuses += checkedStatuses == '' ? 'Hyväksytty' : ',Hyväksytty';
      }
      if ($('#chkHylätty').is(':checked')) {
        checkedStatuses += checkedStatuses == '' ? 'Hylätty' : ',Hylätty';
      }
      if (checkedStatuses != '') {
        params =
          params == ''
            ? 'statuses=' + checkedStatuses
            : params + '&statuses=' + checkedStatuses;
      }
    }
    return url + params;
  }
  /* --------------START Handling Print Save of Release and Warranty Form ------------------------- */

  let warrantyPreviewVisible = false;
  function closeWarrantyPreviewModal() {

    $('#warrantyPreviewModal').hide();

    $('#warrantyPreviewModal')
      .find('.lm__information-modal__wrapper')
      .removeClass('hidden');

    $('#warrantyPreviewContainer').empty();

    $('body').removeClass('modal-open');
    warrantyPreviewVisible = false;
  }
  function showWarrantyPreviewModal(callback) {

    console.log("SHOW WARRANTY PREVIEW MODAL");

    var container = document.querySelector('.warranty_form_Container');

    if (!container) {
      return;
    }

    var isSwedishForm =
      container.dataset.isSwedish &&
      container.dataset.isSwedish.toLowerCase() === 'true';

    $('#warrantyPreviewTitle').text(
      isSwedishForm
        ? 'Förhandsgranska och bekräfta'
        : 'Esikatsele ja vahvista'
    );
    $('#warrantyPreviewDescription').text(
      isSwedishForm
        ? "Kontrollera uppgifterna. Om uppgifterna är korrekta, skicka formuläret genom att klicka på 'Ja'."
        : "Tarkista tiedot ja jos tiedot ovat oikein lähetä lomake painamalla 'Kyllä'"
    );

    $('#btnWarrantyPreviewSubmit').text(
      isSwedishForm
        ? 'Ja'
        : 'Kyllä'
    );

    $('#btnWarrantyPreviewCancel').text(
      isSwedishForm
        ? 'Avbryt'
        : 'Peruuta'
    );

    $('#warrantyPreviewModal').show();

    $('#warrantyPreviewModal')
      .find('.lm__information-modal__wrapper')
      .removeClass('hidden');

    $('body').addClass('modal-open');
    warrantyPreviewVisible = true;
    $('#btnWarrantyPreviewSubmit')
      .off('click')
      .one('click', function () {

        closeWarrantyPreviewModal();
        callback();
      });

    $('#btnWarrantyPreviewCancel')
      .off('click')
      .one('click', function () {

        closeWarrantyPreviewModal();
      });
  }
  function buildWarrantyPreview() {

    console.log("BUILD WARRANTY PREVIEW");

    var $sourceContainer = $('.warranty_form_Container');

    if (!$sourceContainer.length) {
      console.warn("Warranty form container not found.");
      return false;
    }

    var $preview = $sourceContainer.clone(false, false);

    $preview.find('.FormSubmitButton').remove();
    $preview.find('script').remove();

    $('#warrantyPreviewContainer')
      .empty()
      .append($preview);

    console.log("Warranty preview generated.");
    return true;
  }

  function initializeWarrantyPrintAndSubmit() {

    // Run only on pages that contain the warranty form.
    var warrantyContainer = document.querySelector('.warranty_form_Container');

    if (!warrantyContainer) {
      return;
    }

    // Find the submit button inside the warranty form only.
    var submitButton = warrantyContainer.querySelector('.FormSubmitButton');

    if (!submitButton) {
      return;
    }

    submitButton.addEventListener(
      "click",
      function (e) {

        if ($(this).data("warrantyPrintCompleted")) {
          return true;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // EMAIL VALIDATION FIRST
        var emailValid = validateWarrantyEmails();

        if (!emailValid) {
          return;
        }

        // FORM VALIDATION
        var form = submitButton.closest("form");

        if (form && !form.checkValidity()) {
          form.reportValidity();
          return;
        }

        // BUILD PREVIEW; STOP IF NO WARRANTY FORM CONTAINER IS LOADED 
        if (!buildWarrantyPreview()) {
          return;
        }

        // SHOW PREVIEW AND CONTINUE AFTER CONFIRMATION
        showWarrantyPreviewModal(function () {

          function afterPrint() {

            window.removeEventListener("afterprint", afterPrint);

            $(submitButton).data("warrantyPrintCompleted", true);

            submitButton.disabled = false;

            setTimeout(function () {

              if (form && $(submitButton).data("warrantyPrintCompleted")) {
                if (typeof form.requestSubmit === "function") {
                  form.requestSubmit(submitButton);
                }
                else {
                  form.submit();
                }
              }

            }, 500);
          }

          window.addEventListener("afterprint", afterPrint);

          window.print();
        });
      }, true);
  }

  document.addEventListener("click", function (event) {

    if (!warrantyPreviewVisible) {
      return;
    }

    const target = event.target;

    if (
      target &&
      typeof target.closest === "function" &&
      target.closest(".lm__information-modal")
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

  }, true);
  $(document).ready(function () {

    initializeWarrantyPrintAndSubmit();

  });

  /* --------------END Handling Print Save of Release and Warranty Form ------------------------- */

  $('#example').on('click', 'tr:not(.headerRow)', function () {
    $('#hdnFormSubmissionId').val($(this).find('.submissionId').text());
    $('#preview').modal('show');
    $('#preview').fadeIn();
  });

  $('#oldxformdata').on('click', 'tr', function () {
    $('#hdnFormSubmissionId').val($(this).find('.submissionId').text());
    $('#previewXFormEntry').modal('show');
    $('#previewXFormEntry').fadeIn();
  });
  $('#WarrantyFormData').on('click', 'tr:not(.headerRow)', function () {
    window.location.href =
      window.location.href + 'comments?id=' + $(this).find('.submissionId').text();
  });

  $('#WarrantyFormData thead').on('click', 'a', function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  $('#btnSearch').click(function () {
    BindReleaseAndWarrantyFormData();
  });
  $('#btnSearchOldEntries').click(function () {
    BindOldXFormData();
  });
  $('#btnSearchWarrantyData').click(function () {
    BindWarrantyFormData();
  });

  $('#frmWarrantyform').validate({
    errorElement: 'span',
  });

  if ($('#dtSerialNumbers').length) {
    $('#dtSerialNumbers').DataTable({
      bFilter: true,
      bServerSide: false,
      oLanguage: {
        sUrl: dataTableLangLocationUrl,
      },
    });
  }

  $(document).ready(function () {

    var table = $('#dtStoreDetails');

    if (table.length) {
      table.DataTable({
        bFilter: true,
        bServerSide: false,
        oLanguage: {
          sUrl: dataTableLangLocationUrl
        }
      });
    }
  });

  $('#preview').on('show.bs.modal', function (e) {
    $.ajax({
      type: 'GET',
      url:
        '/api/epiformsdata/warrantyformbysubmissionid?submissionId=' +
        $('#hdnFormSubmissionId').val(),
      success: function (data) {
        var formFieldJson = JSON.parse($('#hdnFormFieldsJson').val());
        $('#CustomerFirstName').text(data[formFieldJson.CustomerFirstName] || '');
        $('#CustomerLastName').text(data[formFieldJson.CustomerLastname] || '');
        $('#CustomerYritys').text(data[formFieldJson.CustomerYritys] || '');
        $('#CustomerYTunnus').text(data[formFieldJson.CustomerYTunnus] || '');
        $('#CustomerKatuosoite').text(data[formFieldJson.CustomerKatuosoite] || '');
        $('#CustomerPostinumero').text(data[formFieldJson.CustomerPostinumero] || '');
        $('#CustomerPostitoimipaikka').text(data[formFieldJson.CustomerPostiPaika] || '');
        $('#CustomerAsiakasnumero').text(data[formFieldJson.CustomerAsiakasnumero] || '');
        $('#CustomerPuhelinnumero').text(data[formFieldJson.CustomerPuhelinnumero] || '');
        $('#CustomerSähköposti').text(data[formFieldJson.CustomerSahkoposti] || '');
        $('#SalesmenNimi').text(data[formFieldJson.MyjjaNimi] || '');
        $('#SalesmenSähköposti').text(data[formFieldJson.MyjjaSahkoposti] || '');
        $('#SalesmenKauppa').text(data[formFieldJson.MyjjaKauppa] || '');
        $('#SalesmenY-tunnus').text(data[formFieldJson.MyjjaYtunnus] || '');
        $('#SalesmenKatuosoite').text(data[formFieldJson.MyjjaKatuosoite] || '');
        $('#SalesmenPostinumero').text(data[formFieldJson.MyjjaPostinumero] || '');
        $('#SalesmenPostitoimipaikka').text(
          data[formFieldJson.MyjjaPostitoimipaikka] || ''
        );
        $('#Valmistaja').text(data[formFieldJson.KoneValmistaja]?.split('/')[0] || '');
        $('#Malli').text(data[formFieldJson.KoneMalli]?.split('/')[0] || '');
        $('#Työleveys').text(data[formFieldJson.KoneMalli]?.split('/')[1] || '');
        $('#MachineSarjanumero').text(data[formFieldJson.KoneSarjanumero] || '');
        $('#Lisävarusteetnimi').text(data[formFieldJson.KoneLisävarusteetNimi] || '');
        $('#Lisävarusteetsarjanumero').text(
          data[formFieldJson.KoneLisävarusteetSarjanumero] || ''
        );
        $('#Referenssinumero').text(data[formFieldJson.KoneReferenssinumero] || '');
        $('#Merkkimalli').text(data[formFieldJson.MoottoriMerkkiMalli] || '');
        $('#MotorSarjanumero').text(data[formFieldJson.MoottoriSarjanumero] || '');
        $('#Huoltoliike').text(data[formFieldJson.Huoltoliike]?.split('_')[0] || '');
        $('#ToinenHuoltoliike').text(
          data[formFieldJson.ToinenHuoltoliike]?.split('_')[0] || ''
        );
        $('#Varaosaliike').text(data[formFieldJson.Varaosaliike]?.split('_')[0] || '');
        $('#Luovutuspäivämäärä').text(data[formFieldJson.Luovutuspaivamaara] || '');
        $('#Ajokilometritkäyttötunnit').text(
          data[formFieldJson.AjokilometritKäyttötunnit] || ''
        );
        $('#Paikka').text(data[formFieldJson.Paikka] || '');
        $('#Aika').text(data[formFieldJson.Aika] || '');

        if (data[formFieldJson.Oikeatkayttomenetelmat] === 'Kyllä') {
          $('#chkOikeat').prop('checked', true);
        }
        if (data[formFieldJson.Turvallisuustarkastuksen] === 'Kyllä') {
          $('#chkTurvallisuustarkastuksen').prop('checked', true);
        }
        if (data[formFieldJson.Takuuehdot] === 'Kyllä') {
          $('#chkTakuuehdot').prop('checked', true);
        }
        if (data[formFieldJson.Käyttöohje] === 'Kyllä') {
          $('#checkKayttoojhe').prop('checked', true);
        }
        if (data[formFieldJson.CEe - vaatimustenmukaisuusvakuutus] === 'Kyllä') {
          $('#chkCE').prop('checked', true);
        }
        if (data[formFieldJson.NimeäniJaYhteystietojani] === 'Kyllä') {
          $('#chkNimeaniJaYhteystietojani').prop('checked', true);
        }
      },
    });
  });

  $('#previewXFormEntry').on('show.bs.modal', function (e) {
    $.ajax({
      type: 'GET',
      url: '/api/epiformsdata/XFormdataById?StoreId=' + $('#hdnFormSubmissionId').val(),
      success: function (data) {
        $('#CustomerFirstName').text(data.CustomerFirstName);
        $('#CustomerLastName').text(data.CustomerLastName);
        $('#CustomerYTunnus').text(data.CustomerVatNumber);
        $('#CustomerKatuosoite').text(data.CustomerAddress);
        $('#CustomerPostinumero').text(data.CustomerPostalCode);
        $('#CustomerPostitoimipaikka').text(data.CustomerMunicipality);
        $('#CustomerAsiakasnumero').text(data.CustomerCustomerNumber);
        $('#CustomerPuhelinnumero').text(data.CustomerPhoneNumber);
        $('#CustomerSähköposti').text(data.CustomerEmail);
        $('#SalesmenNimi').text(data.SalesmanName);
        $('#SalesmenSähköposti').text(data.SalesmanEmail);
        $('#SalesmenKauppa').text(data.SalesmanStoreName);
        $('#SalesmenY-tunnus').text(data.SalesmanVatNumber);
        $('#SalesmenKatuosoite').text(data.SalesmanStreetAddress);
        $('#SalesmenPostinumero').text(data.SalesmanPostalCode);
        $('#SalesmenPostitoimipaikka').text(data.SalesmanMunicipality);
        $('#Valmistaja').text(data.MachineManufacturerName);
        $('#Malli').text(data.MachineBrandName);
        $('#Työleveys').text(data.MachineModelName);
        $('#MachineSarjanumero').text(data.MachineSerialNumber);
        $('#Lisävarusteetnimi').text(data.MachineAccessoriesName);
        $('#Lisävarusteetsarjanumero').text(data.MachineAccessoriesSerialNumber);
        $('#Referenssinumero').text(data.MachineReferenceNumber);
        $('#Merkkimalli').text(data.EngineBrandAndModel);
        $('#MotorSarjanumero').text(data.EngineSerialNumber);
        $('#Huoltoliike').text(data.ServiceServiceStoreName);
        $('#Varaosaliike').text(data.ServiceSparePartsStoreName);
        $('#Luovutuspäivämäärä').text(data.ReleaseReleaseDate);
        $('#Ajokilometritkäyttötunnit').text(data.ReleaseMileage);
        $('#Paikka').text(data.SignatureLocation);
        $('#Aika').text(data.SignatureDate);

        $('#chkOikeat').removeAttr('checked');
        $('#chkTurvallisuustarkastuksen').removeAttr('checked');
        $('#chkTakuuehdot').removeAttr('checked');
        $('#checkKayttoojhe').removeAttr('checked');
        $('#chkCE').removeAttr('checked');
        $('#chkNimeaniJaYhteystietojani').removeAttr('checked');
        if (data.DocumentsUsageManual == 'TRUE' || data.DocumentsUsageManual == 'Kyllä') {
          $('#checkKayttoojhe').prop('checked', 'checked');
        }
        if (
          data.MarketingApproveForMarketing == 'TRUE' ||
          data.MarketingApproveForMarketing == 'Kyllä'
        ) {
          $('#chkNimeaniJaYhteystietojani').prop('checked', 'checked');
        }
      },
    });
  });

  $(document).on('click', '.deleteEntry', function () {
    var serialNumber = $(this).attr('title');
    var storeId = $(this).attr('id');
    var button = $(this);
    if (confirm('Haluatko varmasti poistaa ' + serialNumber + ' ?')) {
      $.ajax({
        url: window.location.href + '/deleteentry?storeId=' + storeId,
        method: 'GET',
        contentType: 'application/Json',
        success: function (data) {
          button.closest('tr').hide();
        },
      });
    } else {
      return false;
    }
  });

  function BindReleaseAndWarrantyFormData() {
    if ($('#example').length) {
      var table = $('#example').dataTable();
      if (table != null) {
        table.fnDestroy();
      }
      var url = PrepareUrl();
      table = $('#example').dataTable({
        bServerSide: true, // for show progress bar
        bProcessing: true, // for process server side
        bFilter: false, // this is for disable filter (search box)
        bPaginate: true,
        orderMulti: false, // for disable multiple column at once
        bLengthChange: true,
        sAjaxSource: url,
        aoColumns: [
          {
            data: 'SubmittedOn',
            mRender: function (data) {
              return (
                data.split('/')[0] +
                '<label class="submissionId" style="display:None" >' +
                data.split('/')[1] +
                '</label > '
              );
            },
          },
          { data: 'DateOfDelivery' },
          { data: 'CustomerFirstName' },
          { data: 'CustomerLastName' },
          { data: 'CustomerBusinessName' },
          { data: 'CustomerBusinessId' },
          { data: 'CustomerPostOffice' },
          { data: 'CustomerEmail' },
          { data: 'SalesmenName' },
          { data: 'SalesmenEmail' },
          { data: 'SalemenStore' },
          { data: 'ManufactureName' },
          { data: 'Brand' },
          { data: 'Model' },
          { data: 'SerialNumber' },
          { data: 'SparePartsStore' },
          { data: 'ServicePointStore' },
        ],
        oLanguage: {
          sUrl: dataTableLangLocationUrl,
        },
      });
    }
  }

  function BindOldXFormData() {
    if ($('#oldxformdata').length) {
      var table = $('#oldxformdata').dataTable();
      if (table != null) {
        table.fnDestroy();
      }
      var url = PrepareUrl('oldxformdata');
      table = $('#oldxformdata').dataTable({
        bServerSide: true, // for show progress bar
        bProcessing: true, // for process server side
        bFilter: false, // this is for disable filter (search box)
        bPaginate: true,
        orderMulti: false, // for disable multiple column at once
        bLengthChange: false,
        sAjaxSource: url,
        aoColumns: [
          {
            data: 'SubmittedOn',
            mRender: function (data) {
              return (
                data.split('=')[0] +
                '<label class="submissionId" style="display:None" >' +
                data.split('=')[1] +
                '</label > '
              );
            },
          },
          { data: 'CustomerFirstName' },
          { data: 'CustomerLastName' },
          { data: 'CustomerBusinessId' },
          { data: 'CustomerPostOffice' },
          { data: 'CustomerEmail' },
          { data: 'SalesmenName' },
          { data: 'SalesmenEmail' },
          { data: 'SalemenStore' },
          { data: 'ManufactureName' },
          { data: 'Brand' },
          { data: 'Model' },
          { data: 'SerialNumber' },
          { data: 'SparePartsStore' },
          { data: 'ServicePointStore' },
        ],
        oLanguage: {
          sUrl: dataTableLangLocationUrl,
        },
      });
    }
  }

  function BindWarrantyFormData() {
    if ($('#WarrantyFormData').length) {
      var table = $('#WarrantyFormData').dataTable();
      if (table != null) {
        table.fnDestroy();
      }
      var url = PrepareUrl('warrantyform');
      table = $('#WarrantyFormData').dataTable({
        bServerSide: true, // for show progress bar
        bProcessing: true, // for process server side
        bFilter: false, // this is for disable filter (search box)
        bPaginate: true,
        orderMulti: false, // for disable multiple column at once
        bLengthChange: true,
        ordering: false,
        sAjaxSource: url,
        aoColumns: [
          { data: 'StoreId' },
          { data: 'Status' },
          {
            data: 'HuoltoliikkeenNimi',
            mRender: function (data) {
              return (
                data.split('$')[0] +
                '<label class="submissionId" style="display:None" >' +
                data.split('$')[1] +
                '</label> '
              );
            },
          },
          { data: 'Toimipaikka' },
          { data: 'PuhelinNumero' },
          { data: 'HuoltoliikkeenLaskunNumero' },
          { data: 'KoneenSarjanumero' },
          { data: 'KoneenMerkkiJaMalli' },
          { data: 'TakuunAlkamispaivamaara' },
          { data: 'HehtaaritPaalitTunnit' },
          { data: 'VaurionPaivamaara' },
          { data: 'KorjauksenPaivamaara' },
          { data: 'AsiakasEtunimi' },
          { data: 'AsiakasSukunimi' },
          {
            data: 'Paivamaara',
          },
        ],
        oLanguage: {
          sUrl: dataTableLangLocationUrl,
        },
      });
    }
  }

  function prefillSellerInfo() {
    if ($('.warranty_form_Container').length > 0) {
      var container = $('.warranty_form_Container');
      var pageId = container.data('page-id');
      var isSwedishForm = container.data('is-swedish').toLowerCase();
      $.ajax({
        url: '/api/epiformsdata/loggedincustomerinfo?pageId=' + pageId,
        method: 'GET',
        contentType: 'application/json',
        async: false,
        success: function (data) {
          if (isSwedishForm === "true") {
            var name = getFieldIdByValue(data.formFields, "Säljarensnamn*")
            $('input[name=' + name + ']').val(data.dbUser.Name);
            name = getFieldIdByValue(data.formFields, "Säljarensepost*")
            $('input[name=' + name + ']').val(data.dbUser.Email);
            $('select[name=' + getFieldIdByValue(data.formFields, "Säljarensbutik*") + ']').val(
              data.dbUser.CustomerName
            );
            name = getFieldIdByValue(data.formFields, "SäljarensFOnummer")
            $('input[name=' + name + ']').val(data.dbUser.OrganisationNo);
            name = getFieldIdByValue(data.formFields, "Säljarensgatuadress")
            $('input[name=' + name + ']').val(data.dbUser.Street);
            name = getFieldIdByValue(data.formFields, "Säljarenspostnummer")
            $('input[name=' + name + ']').val(data.dbUser.Zip);
            name = getFieldIdByValue(data.formFields, "SäljarensPostkontor")
            $('input[name=' + name + ']').val(data.dbUser.City);
          }
          else {
            var name = data.formFields.MyjjaNimi;
            $('input[name=' + name + ']').val(data.dbUser.Name);
            name = data.formFields.MyjjaSahkoposti;
            $('input[name=' + name + ']').val(data.dbUser.Email);
            $('select[name=' + data.formFields.MyjjaKauppa + ']').val(data.dbUser.CustomerName);
            name = data.formFields.MyjjaYtunnus;
            $('input[name=' + name + ']').val(data.dbUser.OrganisationNo);
            name = data.formFields.MyjjaKatuosoite;
            $('input[name=' + name + ']').val(data.dbUser.Street);
            name = data.formFields.MyjjaPostinumero;
            $('input[name=' + name + ']').val(data.dbUser.Zip);
            name = data.formFields.MyjjaPostitoimipaikka;
            $('input[name=' + name + ']').val(data.dbUser.City);
            name = data.formFields.Paikka;
            $('input[name=' + name + ']').val(data.dbUser.City);
          }
        },
      });
    }
  }

  /**
 * Ensures customer & seller email are NOT the same
 * Works on input/change AND on submit
 * Compatible with Optimizely + MutationObserver
 */
  function getEmailFieldNames() {
    var raw = $.trim($('#releaseFormEmailFieldsIdsJson').text());
    if (!raw || raw.indexOf(',') === -1) {
      return [];
    }

    return raw
      .split(',')
      .map(function (s) {
        return $.trim(s);
      })
      .filter(Boolean);
  }

  function showEmailError($input, message) {

    var $container = $input.closest('.Form__Element');
    var $error = $container.find('.Form__Element__ValidationError');

    $container.addClass('ValidationFail');

    setTimeout(function () {
      $error
        .text(message)
        .removeClass('hidden')
        .attr('data-custom-email-error', 'true');

    }, 0);
  }

  function clearEmailError($input) {
    var $container = $input.closest('.Form__Element');
    var $error = $container.find('.Form__Element__ValidationError');

    if ($error.attr('data-custom-email-error') === 'true') {
      $container.removeClass('ValidationFail');

      $error
        .addClass('hidden')
        .text('')
        .removeAttr('data-custom-email-error');
    }
  }

  function validateWarrantyEmails() {
    var container = document.querySelector('.warranty_form_Container');

    if (!container) {
      return true;
    }

    var isSwedishForm =
      container.dataset.isSwedish &&
      container.dataset.isSwedish.toLowerCase() === 'true';

    var errorMessage = isSwedishForm
      ? 'Kundens och säljarens e-postadress kan inte vara densamma, ange en ny e-postadress.'
      : 'Asiakkaan ja myyjän sähköposti ei voi olla sama, anna uusi sähköposti.';

    var fields = getEmailFieldNames();

    if (fields.length !== 2) {
      return true;
    }

    var $email1 = $('input[name="' + fields[0] + '"]');
    var $email2 = $('input[name="' + fields[1] + '"]');

    if (!$email1.length || !$email2.length) {
      return true;
    }

    var email1 = $.trim($email1.val()).toLowerCase();
    var email2 = $.trim($email2.val()).toLowerCase();

    if (email1 && email2 && email1 === email2) {

      showEmailError($email1, errorMessage);
      showEmailError($email2, errorMessage);

      return false;
    }

    clearEmailError($email1);
    clearEmailError($email2);

    return true;
  }
  function validateCustomerAndSellersEmailDuplication() {

    var container = document.querySelector('.warranty_form_Container');
    if (!container || !container.dataset || typeof container.dataset.isSwedish !== 'string') {
      return;
    }

    var isSwedishForm = container.dataset.isSwedish.toLowerCase() === 'true';

    var fields = getEmailFieldNames();
    if (fields.length !== 2) return;

    var $email1 = $('input[name="' + fields[0] + '"]');
    var $email2 = $('input[name="' + fields[1] + '"]');

    if (!$email1.length || !$email2.length) return;

    // ---------------------------------------------
    // Error message
    // ---------------------------------------------
    var errorMessage = isSwedishForm
      ? 'Kundens och säljarens e‑postadress kan inte vara densamma, ange en ny e‑postadress.'
      : 'Asiakkaan ja myyjän sähköposti ei voi olla sama, anna uusi sähköposti.';


    // ---------------------------------------------
    // Bind input/change (live validation)
    // ---------------------------------------------
    var debounceTimer;
    function debouncedValidate() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(validateWarrantyEmails, 300);
    }

    $email1.on('input change', debouncedValidate);
    $email2.on('input change', debouncedValidate);

    validateWarrantyEmails();
    // ---------------------------------------------
    // bind submit button
    // ---------------------------------------------

    var form = container.querySelector('form');

    form?.addEventListener('submit', function (e) {
      var isValid = validateWarrantyEmails();

      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }

    }, true);
  }

  function bindStoreDetails() {
    var $container = $('.warranty_form_Container');

    if (!$container.length) {
      console.warn("Form container not found");
      return;
    }

    // Read JSON from hidden div
    var $jsonDiv = $container.find('#releaseFormStoreRelatedFieldsIdsJson');

    if (!$jsonDiv.length) {
      console.warn("JSON div not found");
      return;
    }

    var rawText = $jsonDiv.html();

    if (!rawText) {
      console.warn("JSON content empty");
      return;
    }

    var fieldMapping = {};

    try {
      fieldMapping = JSON.parse(rawText.trim());
    } catch (e) {
      console.error("Invalid JSON:", e);
      return;
    }

    //Remove old bindings (important in Optimizely)
    $container.off('change', '.ddlStoreListDetails .ddlStoreList');

    //Bind dropdown change
    $container.on('change', '.ddlStoreListDetails .ddlStoreList', function () {
      var selectedStore = $(this).val();

      if (!selectedStore) {
        clearFields();
        return;
      }

      $.ajax({
        url: '/api/storeManagement/storedetails',
        type: 'GET',
        data: { storeName: selectedStore },

        success: function (response) {

          if (!response) return;

          //Set values using mapping
          setFieldValue(fieldMapping.BusinessId, response.BusinessId);
          setFieldValue(fieldMapping.StreetAddress, response.StreetAddress);
          setFieldValue(fieldMapping.PostalCode, response.PostalCode);
          setFieldValue(fieldMapping.PostalArea, response.PostalArea);
        },

        error: function (err) {
          console.error('Error fetching store data:', err);
          clearFields();
        }
      });
    });


    // Helper: Set value using field name
    function setFieldValue(fieldName, value) {

      if (!fieldName) return;

      var $input = $container.find('[name="' + fieldName + '"]');

      if ($input.length) {
        $input.val(value || '').trigger('change');
      } else {
        console.warn("Field not found:", fieldName);
      }
    }


    // Helper: Clear all mapped fields
    function clearFields() {

      if (!fieldMapping) return;

      Object.keys(fieldMapping).forEach(function (key) {
        setFieldValue(fieldMapping[key], '');
      });
    }
  }

  //BOTH triggers
  $(function () {
    bindStoreDetails();
  });

  $(document).on('epiforms:ready', function () {
    bindStoreDetails();
  });

  function bindStoreDetailsWhenReady() {

    const observer = new MutationObserver(function () {

      if ($('#releaseFormStoreRelatedFieldsIdsJson').length) {
        observer.disconnect(); // stop observing
        bindStoreDetails(); // actual function
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  bindStoreDetailsWhenReady();
  function getFieldIdByValue(formFields, searchValue) {
    if (!formFields || !searchValue) {
      return "";
    }

    var foundFieldId = "";

    $.each(formFields, function (key, value) {
      if (value === searchValue) {
        foundFieldId = key;
        return false;
      }
    });

    return foundFieldId;
  }


  $(document).ready(function () {
    //This function is used to translate the Finnish success message to swedish language if the Swedish release and warranty form is submitted.
    var handled = false;
    var svHtmlContainer = $("#svSuccessHtml");
    var swedishHtml = svHtmlContainer.html();

    // Helper: is this a Swedish form page?
    function isSwedishFormPage() {
      var $container = $(".warranty_form_Container");
      if (!$container.length) return false;

      var flag = $container.data("is-swedish");
      return flag === true || flag === "True";
    }

    const observer = new MutationObserver(function () {

      if (handled) return;

      var $status = $(".Form__Status__Message");

      if (
        $status.length &&
        $status.is(":visible") &&
        $status.text().trim().length > 0
      ) {
        handled = true;

        //replace FI message with Swedish HTML
        if (isSwedishFormPage()) {
          $status.html(swedishHtml);
        }

        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true
    });
  });



  $(".Form__MainBody input[title='enintään 30 merkkiä']").attr('maxLength', '30');
  $(".Form__MainBody input[title='Tuoteryhmä']").parent('.Form__Element').css('display', 'none');
  $(".Form__MainBody select[title='Tuoteryhmä']").change(function () {
    if ($(this).val() != 'Other') {
      $(".Form__MainBody input[title='Tuoteryhmä']").val($(this).val());
      $(".Form__MainBody input[title='Tuoteryhmä']")
        .parent('.Form__Element')
        .css('display', 'none');
    } else {
      $(".Form__MainBody input[title='Tuoteryhmä']").val('');
      $(".Form__MainBody input[title='Tuoteryhmä']")
        .parent('.Form__Element')
        .css('display', 'inline-block');
      $('button').css('display', 'block');
    }
  });

  $('#btnUpdateWarrantyFormSubmitterName').click(function () {
    let storesListTo;
    let storesListFrom;
    if ($('#ddlStoresListFrom').val() != undefined && $('#ddlStoresListFrom').val() != '') {
      storesListFrom = $('#ddlStoresListFrom').val();
    }
    if ($('#ddlStoresListTo').val() != undefined && $('#ddlStoresListTo').val() != '') {
      storesListTo = $('#ddlStoresListTo').val();
    }

    $.ajax({
      type: 'POST',
      url: '/api/warrantyform/submit',
      data: JSON.stringify({
        EmailId: $('#txtEmailFromId').val(),
        FromStore: storesListFrom,
        ToStore: storesListTo,
      }),
      contentType: 'application/json',
      success: function (response) {
        $('#txttotalUpdatedRecords').show();
        $('#txtRecordUpdatedCnt').show();
        $('#txtRecordUpdatedCnt').html(response);
      },
      error: function (e) {
        console.log('Something went wrong with the AJAX SubmitterNameChange request!');
        console.log(e.responseText);
      },
    });
  });

  const charASCIICode0 = 48;
  const charASCIICode9 = 57;

  function isNumberKey(evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode >= charASCIICode0 && charCode <= charASCIICode9) return true;
    return false;
  }
  $(document).on('keypress', '.priceMonth', function (event) {
    return numbersonly(event);
  });

  function numbersonly(e) {
    if (isNaN(e.key) && e.key !== '-' && e.key !== '/') e.preventDefault();
  }

  $(document).on('keypress', '.grainPrice', function (event) {
    return isNumberKey(event);
  });

  $('#btnExportToExcel').click(function () {
    var query = $('#txtSearchInput').val();
    var fromDate = $('#txtFromDate').val();
    var toDate = $('#txtToDate').val();
    var skip = 0; // Adjust based on your needs (for example, export all data)
    var take = 1000; // Adjust based on your needs

    window.location.href =
      '/api/graintrade/exportcontracts?query=' +
      query +
      '&fromDate=' +
      fromDate +
      '&toDate=' +
      toDate +
      '&skip=' +
      skip +
      '&take=' +
      take;
  });

  $('#btnExportwarrantyformdataToExcel').click(function () {
    var params = '';
    if ($('#txtSearchInput').val() != '') {
      params = 'query=' + $('#txtSearchInput').val();
    }
    if ($('#ddlStores').val() != undefined && $('#ddlStores').val() != '') {
      params =
        params == ''
          ? 'store=' + $('#ddlStores').val()
          : params + '&store=' + $('#ddlStores').val();
    }
    if ($('#ddlManufacturer').val() != '') {
      params =
        params == ''
          ? 'manufacturer=' + $('#ddlManufacturer').val()
          : params + '&manufacturer=' + $('#ddlManufacturer').val();
    }
    if ($('#txtFromDate').val() != '') {
      params =
        params == ''
          ? 'fromDate=' + $('#txtFromDate').val()
          : params + '&fromDate=' + $('#txtFromDate').val();
    }
    if ($('#txtToDate').val() != '') {
      params =
        params == ''
          ? 'toDate=' + $('#txtToDate').val()
          : params + '&toDate=' + $('#txtToDate').val();
    }
    if ($('#chkSelf').is(':checked')) {
      params = params == '' ? 'submittedByMe=true' : params + '&submittedByMe=true';
    }
    window.location.href = '/api/epiformsdata/exportreleaseandwarrantyform?' + params;
  });

  $('#uploadFileWarrantyForm').change(function () {
    const allowedFormatsArray = $(this).attr('data-allowedFormats');
    var errorSpan = $('#uploadFileError');
    var submitBtn = $('#btnSubmit');
    errorSpan.hide();
    for (var i = 0; i < $(this).get(0).files.length; ++i) {
      const file = $(this).get(0).files[i];
      var extension = file.name.split('.').pop();
      if (!allowedFormatsArray.includes(extension)) {
        errorSpan.show();
        submitBtn.prop('disabled', true);
        submitBtn.css('background-color', '#E9ECE9');
        return;
      }
    }
    submitBtn.removeAttr('disabled');
    submitBtn.removeAttr('style');
  });
});
